import React, { PureComponent } from 'react';
import { connect } from 'react-redux'
import Wrapermap  from './wraper-map';
import Menu  from './menu';

const mapStateToProps = state => {
    return {
        dataToPlot: state.urlquery
    }
};

class DomStruct extends PureComponent {
    render() {
        return (
            <div id="fullWindow" style={{width: '100%', height: '100vh', position: 'relative'}}>
                <Menu dataToPlot={this.props.dataToPlot} />
                <Wrapermap />
            </div>
        )
    }
}

const WTM_map = connect(mapStateToProps)(DomStruct)

export default WTM_map



// WEBPACK FOOTER //
// ./src/components/wtm.cont.js